import { NotFound } from '@carouselgg/nexus/status-page'

export function AppNotFound() {
  return <NotFound homePath="/" />
}
